<section
  id="tvd-program-details-table"
  class="px-8 pt-6 pb-neptune-bar ml-neptune-sidebar flex flex-col mb-neptune-bar"
>
  <!-- Sticky toolbar -->
  <section
    id="tvd-program-details-table-toolbar"
    class="neptune-advanced-filters flex flex-col px-8 py-4 gap-4 bg-white"
  >
    <section
      id="tvd-program-details-table-breadcrumb"
      class="flex items-center gap-2 my-4"
    >
      <!-- Programs -> Program Products -> Product Locations -->
      <a
        data-id="tvd-link"
        [routerLink]="'/total-value-delivery'"
        [fragment]="'tvd-program-table'"
        class="program-link neptune-link-blue"
      >
        Programs
      </a>
      <div class="chevron flex items-center">
        <img src="assets/chevron-right.svg" alt="chevron-right" />
      </div>

      <!-- Breadcrumb Program name if in Location view or just a normal span-->
      <ng-container
        *ngIf="
          currentView === TvdProgramDrillDownGrouping.Location;
          else programName
        "
      >
        <a
          class="program-name-breadcrumb neptune-link-blue"
          (click)="navigateToProductsView()"
        >
          {{ selectedProgramName || "Program Details" }}
        </a>
      </ng-container>

      <ng-template #programName>
        <span
          *ngIf="currentView === TvdProgramDrillDownGrouping.Product"
          class="program-name-breadcrumb cursor-default neptune-link-blue"
          >{{ selectedProgramName || "Program Details" }}</span
        >
      </ng-template>

      <ng-container
        *ngIf="currentView === TvdProgramDrillDownGrouping.Location"
      >
        <div class="chevron flex items-center">
          <img src="assets/chevron-right.svg" alt="chevron-right" />
        </div>
        <span class="product-name-breadcrumb neptune-link-blue"
          >{{ selectedProductName }} Locations</span
        >
      </ng-container>
    </section>

    <section
      id="tvd-program-details-table-filters-paginator-row"
      class="flex flex-wrap justify-between gap-4 mb-4"
    >
      <div class="tvd-program-details-table-filters flex gap-2">
        <div id="tvd-program-details-table-region-filter" class="relative w-64">
          <multi-select-input
            [label]="'Region'"
            [floatingLabel]="true"
            [options]="availableRegions"
            [values]="selectedRegions"
            [displayFn]="getRegionDisplayName.bind(this)"
            [multiSelectionSummarySuffix]="'Regions Selected'"
            [ariaLabel]="'Region filter options'"
            (valuesChange)="onRegionFilterChange($event)"
            [noOptionsMessage]="'No regions available for selected filters'"
          ></multi-select-input>
        </div>

        <div
          id="tvd-program-details-table-impact-category-filter"
          class="relative w-64"
        >
          <multi-select-input
            [label]="'Impact Category'"
            [floatingLabel]="true"
            [options]="availableImpactCategories"
            [values]="selectedImpactCategories"
            [multiSelectionSummarySuffix]="'Categories Selected'"
            [ariaLabel]="'Impact category filter options'"
            (valuesChange)="onImpactCategoryFilterChange($event)"
            [noOptionsMessage]="'No impact categories available for selected filters'"
          ></multi-select-input>
        </div>
      </div>

      <div id="tvd-program-details-table-paginator">
        <paginator
          [currentPage]="pageIndex + 1"
          [totalItems]="currentViewTotalItems"
          [limit]="pageSize"
          [pageSizeOptions]="pageSizeOptions"
          (pageChange)="onPageChange($event)"
        >
        </paginator>
      </div>
    </section>
  </section>

  <!-- Product and Location Views -->
  <ng-container *ngIf="!isLoading; else loader">
    <!-- Product View -->
    <ng-container *ngIf="currentView === TvdProgramDrillDownGrouping.Product">
      <section
        id="tvd-program-details-table-product-view"
        class="px-8 bg-white pb-8"
      >
        <table
          class="w-full border-collapse text-sm"
          *ngIf="productTableRows.length > 0; else noProductRows"
        >
          <thead
            class="tvd-program-details-table-product-headers border-neptune-border-subtle neptune-border-b-1 bg-neptune-muted"
          >
            <tr>
              <th class="product-col-header text-left px-4 py-4 text-blue">
                Product
              </th>
              <th
                class="impact-categories-col-header text-left px-4 py-4 text-blue"
              >
                Impact Categories
              </th>
              <th class="locations-col-header text-center px-4 py-4 text-blue">
                Locations
              </th>
              <th
                class="total-value-delivered-col-header text-center px-4 py-4 text-blue"
              >
                Delivered Value
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let row of pagedProductTableRows; index as i"
              class="border-b-1 last:border-b-0 even:bg-neptune-muted odd:bg-white"
            >
              <td
                class="product-info px-4 py-4 flex flex-col gap-1 items-start"
                [title]="row.productName"
              >
                <span
                  class="product-name text-base font-semibold text-neptune-defaul"
                  >{{ row.productName }}</span
                >
                <span
                  class="product-code text-sm font-semibold text-shuttle-gray"
                  >SKU: {{ row.productCode }}</span
                >
              </td>
              <td
                class="impact-categories px-4 py-4 text-left"
                [title]="row.impactCategories.join(', ')"
              >
                {{ row.impactCategories.join(", ") }}
              </td>
              <td class="location-count p-0 text-center">
                <button
                  type="button"
                  class="w-full h-full px-6 py-4 border-1 border-solid text-black bg-transparent border-neptune-border-subtle rounded-md hover:bg-blue hover:text-white cursor-pointer"
                  (click)="onProductLocationSelected(row)"
                >
                  {{ getUniqueLocationCount(row) }}
                </button>
              </td>
              <td class="total-value-delivered px-4 py-4 text-center">
                <span class="currency-symbol">{{
                  currencyCode | currencySymbol
                }}</span>
                <span class="delivered-value">
                  <ng-container
                    *ngIf="
                      row.totalValueDelivered.value > 0 &&
                        row.totalValueDelivered.value < 1;
                      else actualProductTvdValue
                    "
                  >
                    &lt;1
                  </ng-container>
                  <ng-template #actualProductTvdValue>
                    {{
                      displayInRoundedNumber
                        ? (getDisplayValue(row.totalValueDelivered.value)
                          | abbreviateNumber)
                        : (getDisplayValue(row.totalValueDelivered.value)
                          | number: "1.0-0")
                    }}
                  </ng-template>
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <ng-template #noProductRows>
          <div class="no-data-message px-4 py-6 text-center text-gray-500">
            No products available for the selected filters.
          </div>
        </ng-template>
      </section>
    </ng-container>
    <!-- Location View: Drill down from a product row -->
    <ng-container *ngIf="currentView === TvdProgramDrillDownGrouping.Location">
      <section
        id="tvd-program-details-table-location-view"
        class="px-8 bg-white pb-8"
      >
        <table
          class="w-full border-collapse text-sm"
          *ngIf="locationTableRows.length > 0; else noLocationRows"
        >
          <thead
            class="tvd-program-details-table-location-headers border-neptune-border-subtle neptune-border-b-1 bg-neptune-muted"
          >
            <tr>
              <th class="site-info-col-header text-left px-4 py-4 text-blue">
                Site Info
              </th>
              <th
                class="impact-categories-col-header text-left px-4 py-4 text-blue"
              >
                Impact Categories
              </th>
              <th class="quantity-col-header text-center px-4 py-4 text-blue">
                Quantity
              </th>
              <th
                class="total-value-delivered-col-header text-center px-4 py-4 text-blue"
              >
                Delivered Value
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let row of pagedLocationTableRows; index as i"
              class="border-b-1 last:border-b-0 even:bg-neptune-muted odd:bg-white"
            >
              <td
                class="site-info px-4 py-4 flex flex-col gap-1"
                [title]="row.siteName"
              >
                <span class="site-name font-semibold">{{ row.siteName }}</span>
                <span
                  class="site-address text-sm neptune-shuttle-gray"
                  [title]="
                    row.address +
                    ', ' +
                    row.city +
                    ', ' +
                    row.state +
                    ' ' +
                    row.zipCode
                  "
                >
                  {{ row.address }}, {{ row.city }}, {{ row.state }}
                  {{ row.zipCode }}
                </span>
              </td>
              <td
                class="impact-categories px-4 py-4"
                [title]="row.impactCategories.join(', ')"
              >
                {{ row.impactCategories.join(", ") }}
              </td>
              <td class="quantity px-4 py-4 text-center">
                {{ row.casesPurchased }}
              </td>
              <td class="total-value-delivered px-4 py-4 text-center">
                <span class="currency-symbol">{{
                  currencyCode | currencySymbol
                }}</span>
                <span class="delivered-value">
                  <ng-container
                    *ngIf="
                      row.totalValueDelivered.value > 0 &&
                        row.totalValueDelivered.value < 1;
                      else actualLocTvdValue
                    "
                  >
                    &lt;1
                  </ng-container>
                  <ng-template #actualLocTvdValue>
                    {{
                      displayInRoundedNumber
                        ? (getDisplayValue(row.totalValueDelivered.value)
                          | abbreviateNumber)
                        : (getDisplayValue(row.totalValueDelivered.value)
                          | number: "1.0-0")
                    }}
                  </ng-template>
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <ng-template #noLocationRows>
          <div class="no-data-message px-4 py-6 text-center text-gray-500">
            No locations available for the selected filters.
          </div>
        </ng-template>
      </section>
    </ng-container>
  </ng-container>

  <ng-template #loader>
    <div class="details-loader flex justify-center py-8">
      <loader [size]="'medium'"></loader>
    </div>
  </ng-template>
</section>
